import {Button, EmptyState, Icon, Illustration} from '@sollapay/ui/components';
import {SaveMoneyIllustration} from '@sollapay/ui/illustrations';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

interface BuyersEmptyStateProps {
  /** Omit for read-only access — the empty state still explains the tab, minus the CTA. */
  onAddBuyer?: () => void;
  /** True while the account's existing purchase is still resolving — shows the CTA disabled
   * rather than hiding it, so the affordance doesn't flicker in and out. */
  isAddBuyerPending?: boolean;
}

export const BuyersEmptyState: FC<BuyersEmptyStateProps> = ({
  onAddBuyer,
  isAddBuyerPending = false
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <EmptyState
      illustration={
        <Illustration width={166} height={160}>
          <SaveMoneyIllustration />
        </Illustration>
      }
      title={t('view.buyers.empty.title')}
      subtitle={t('view.buyers.empty.description')}
      action={
        onAddBuyer && (
          <Button
            variant="primary"
            size="sm"
            onClick={onAddBuyer}
            isLoading={isAddBuyerPending}
            icon={<Icon name="add" />}
          >
            {t('view.buyers.empty.action')}
          </Button>
        )
      }
    />
  );
};

export type {BuyersEmptyStateProps};
